import React from 'react';
import '../../styles/main.css';

const style = {
  main: {
    width: '100vw',
    height: '100vh',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    color: '#fff',
  },
  message: {
    margin: 20,
  },
  loading: {
    width: 50,
    height: 50,
    backgroundColor: '#fff',
    borderRadius: 5,
  },
};

const Login = () => (
  <div style={style.main}>
    <div id="circular3dG">
      <div id="circular3d_1G" className="circular3dG" />
      <div id="circular3d_2G" className="circular3dG" />
      <div id="circular3d_3G" className="circular3dG" />
      <div id="circular3d_4G" className="circular3dG" />
      <div id="circular3d_5G" className="circular3dG" />
      <div id="circular3d_6G" className="circular3dG" />
      <div id="circular3d_7G" className="circular3dG" />
      <div id="circular3d_8G" className="circular3dG" />
    </div>
  </div>
);

export default Login;
